module.exports = __webpack_public_path__ + "static/img/keke-ss-01.14fa052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/keke/keke-ss-01.png
// module id = NWA3
// module chunks = 0